import { render, staticRenderFns } from "./DraftPricePreview.vue?vue&type=template&id=bb2db3fc&"
import script from "./DraftPricePreview.vue?vue&type=script&lang=js&"
export * from "./DraftPricePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports